import React from 'react';
import otp from '../assets/ic--baseline-mobile-friendly.png';

export default function VerificationImage() {
  return (
    <div className="mx-auto text-center w-28">
      <img src={otp} className="h-24 w-24 mb-2 mx-auto" alt="Logo" />
      <p className="text-gray-600 font-semibold text-lg">
        Verification
      </p>
    </div>
  );
}
